import { AnyAction, createReducer } from '@reduxjs/toolkit';
import { RequestState } from 'modules/types/common';
import { switchAccountSuccess } from 'store/account/actions';
import * as actions from './actions';
import { PreventativeCareState, PreventativeCareItem } from './types';

export const initialState: PreventativeCareState = {
  isFetching: false,
  error: null,
  data: null,
  requestState: RequestState.INITIALIZED,
  lastUpdated: undefined
};

function getType(str: string) {
  const strLowerCase = str.toLowerCase();

  if (strLowerCase.includes('flu')) {
    return 'fluShot';
  }

  if (strLowerCase.includes('mammogram')) {
    return 'mammogram';
  }

  if (strLowerCase.includes('cervical') && strLowerCase.includes('cancer')) {
    return 'cervicalCancer';
  }

  if (strLowerCase.includes('wellness')) {
    return 'wellness';
  }

  if (strLowerCase.includes('diabetes')) {
    return 'diabetes';
  }

  return 'noTypes';
}

const mapAdvisories = (action: AnyAction) => {
  if (!action?.payload?.data) {
    return null;
  }

  return action.payload.data.map((a: PreventativeCareItem) => ({
    ...a,
    displayText: a.displayText.toLowerCase().replace(/^\w/, (c: string) => c.toUpperCase()),
    type: getType(a.displayText)
  }));
};

const preventativeCareReducer = createReducer(initialState, {
  [actions.GET_PREVENTATIVE_CARE]: state => {
    state.isFetching = true;
    state.error = null;
    state.requestState = RequestState.REQUESTING;
  },
  [actions.GET_PREVENTATIVE_CARE_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.requestState = RequestState.SUCCESS;
    state.data = mapAdvisories(action);
  },
  [actions.GET_PREVENTATIVE_CARE_CACHE_SUCCESS]: (state, action) => {
    state.data = mapAdvisories(action);
    state.lastUpdated = action.payload.cacheUpdatedAt;
  },
  [actions.GET_PREVENTATIVE_CARE_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
    state.requestState = RequestState.ERROR;
  },
  [switchAccountSuccess.type]: () => initialState
});

export default preventativeCareReducer;
